import React, { useMemo } from "react";
import style from "css/admin/component.module.css";
import { Modal, Button, ConfigProvider } from "antd";

function DeleteConfirmModal({ open, onCancel, onConfirm, loading = false, record = null }) {
  const manu = record?.MANUFACTURER_NM ? String(record.MANUFACTURER_NM).trim() : "";
  const prod = record?.PRODUCT_NM ? String(record.PRODUCT_NM).trim() : "";
  const displayName = useMemo(() => [manu, prod].filter(Boolean).join(" "), [manu, prod]);

  const defaultSrc = `${process.env.REACT_APP_CLIENT_URL}icon/logo_w.png`;
  const prodPathNm = manu ? manu.toLowerCase() : "";
  const imgNm = record?.IMG_NM ? String(record.IMG_NM) : "";
  const imgSrc = imgNm ? `${process.env.REACT_APP_CLIENT_URL}img/product/${prodPathNm}/${imgNm}` : defaultSrc;

  return (
    <Modal
      // title={
      //   <span className={style.searchItem_label} style={{ fontSize: 18 }}>
      //     삭제 확인
      //   </span>
      // }
      open={open}
      onCancel={onCancel}
      closable={false}
      maskClosable={!loading}
      styles={{ content: { borderRadius: 12 }, mask: { backdropFilter: "none" } }}
      footer={
        <ConfigProvider
          theme={{
            token: { colorPrimary: "#f65c22" },
            components: {
              Button: {
                colorPrimaryHover: "#e4561f",
                colorPrimaryActive: "#cc4b1b",
              },
            },
          }}
        >
          <div style={{ display: "flex", gap: 8, width: "100%" }}>
            <Button
              key="cancel"
              onClick={onCancel}
              disabled={loading}
              style={{ flex: 1, height: 40, borderRadius: 5, fontSize: 18 }}
            >
              취소
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={onConfirm}
              loading={loading}
              style={{ flex: 1, height: 40, borderRadius: 5, fontSize: 18 }}
            >
              삭제
            </Button>
          </div>
        </ConfigProvider>
      }
      centered
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, paddingTop: 6 }}>
        <img
          src={imgSrc}
          alt={displayName || "Product"}
          className={style.product_table_img}
          style={{ width: 86, height: 86 }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = defaultSrc;
          }}
        />
        <div className={style.searchItem_label} style={{ fontSize: 16, textAlign: "center" }}>
          {displayName || "-"}
        </div>
        <div className={style.searchItem_label} style={{ fontSize: 15, fontWeight: 500, textAlign: "center" }}>
          제품을 삭제하시겠습니까?
        </div>
      </div>
    </Modal>
  );
}

export default DeleteConfirmModal;


